import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export const CharterSelector = ({ selectedCharterId, currentCharters, onChange, renderField, disabled }) => {

	const [ charters, setCharters ] = useState([]);

	const charter = charters.find(item => item.purchaseCharter?.id === selectedCharterId);

	const handleNewCharters = (newCharters) => {
		const newArray = [ ...charters ];

		newCharters.forEach(item => {
			if (!charters.find(c => c.purchaseCharter?.id === item.purchaseCharter?.id)) {
				newArray.push(item);
			}
		});

		setCharters(newArray);
	};

	const handlePrevious = () => {
		const currentIndex = charters.findIndex(c => c.purchaseCharter?.id === charter?.purchaseCharter?.id);
		onChange(charters[currentIndex - 1]);
	};

	const handleNext = () => {
		const currentIndex = charters.findIndex(c => c.purchaseCharter?.id === charter?.purchaseCharter?.id);
		onChange(charters[currentIndex + 1]);
	};

	useEffect(() => {
		handleNewCharters(currentCharters);
	}, [ currentCharters ]);

	const isFirstSelected = charters?.[0]?.purchaseCharter?.id === charter?.purchaseCharter?.id;
	const isLastSelected = charters?.[charters.length - 1]?.purchaseCharter?.id === charter?.purchaseCharter?.id;

	if (charter) {
		return (
			<span className="ship-field">
				<IconButton size="small" onClick={handlePrevious} disabled={isFirstSelected || disabled}>
					<KeyboardArrowLeftIcon />
				</IconButton>

				<span>
					{renderField(charter)}
				</span>

				<IconButton size="small" onClick={handleNext} disabled={isLastSelected || disabled}>
					<KeyboardArrowRightIcon />
				</IconButton>
			</span>
		);
	} else {
		return null;
	}
};
